import { render, staticRenderFns } from "./PdfReminderModal.vue?vue&type=template&id=13d03e3f&"
import script from "./PdfReminderModal.vue?vue&type=script&lang=ts&"
export * from "./PdfReminderModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports